var LabFeature = /* @__PURE__ */ function(LabFeature2) {
  LabFeature2["SMART_COLLECTIONS"] = "smartCollections";
  return LabFeature2;
}({});

export { LabFeature };
//# sourceMappingURL=index.js.map
